import axios from 'axios';

export default (id) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .patch(process.env.VUE_APP_API_ADMIN_LOCATION + `reviews/${id}/verify`)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
